import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Tasks Overview"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-bold fs-7" }, "Pending 10 tasks")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table align-middle gs-0 gy-5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 w-50px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-200px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-100px" }),
    /*#__PURE__*/_createElementVNode("th", { class: "p-0 min-w-40px" })
  ])
], -1)
const _hoisted_10 = { class: "symbol symbol-50px me-2" }
const _hoisted_11 = { class: "symbol-label" }
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary mb-1 fs-6"
}
const _hoisted_14 = { class: "text-muted fw-bold d-block fs-7" }
const _hoisted_15 = { class: "d-flex flex-column w-100 me-2" }
const _hoisted_16 = { class: "d-flex flex-stack mb-2" }
const _hoisted_17 = { class: "text-muted me-2 fs-7 fw-bold" }
const _hoisted_18 = { class: "progress h-6px w-100" }
const _hoisted_19 = ["aria-valuenow"]
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = {
  href: "#",
  class: "\n                      btn btn-sm btn-icon btn-bg-light btn-active-color-primary\n                    "
}
const _hoisted_22 = { class: "svg-icon svg-icon-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown1 = _resolveComponent("Dropdown1")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
          ])
        ]),
        _createVNode(_component_Dropdown1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("th", null, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, [
                      _createElementVNode("img", {
                        src: item.image,
                        class: "h-50 align-self-center",
                        alt: ""
                      }, null, 8, _hoisted_12)
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("a", _hoisted_13, _toDisplayString(item.info.title), 1),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(item.info.description), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(item.progress.value) + "% ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", {
                        class: _normalizeClass(`
                          progress-bar
                          bg-${item.progress.color}
                        `),
                        role: "progressbar",
                        style: _normalizeStyle(`width: ${item.progress.value}%`),
                        "aria-valuenow": item.progress.value,
                        "aria-valuemin": "0",
                        "aria-valuemax": "100"
                      }, null, 14, _hoisted_19)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_20, [
                  _createElementVNode("a", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}